"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationRules = void 0;

var _formUtils = require("../internal/validation/formUtils");

var _valueCheck = require("../internal/utils/valueCheck");

var _states = require("../internal/validation/states");

var emailsAreValid = function emailsAreValid(emails) {
  return emails.every(function (val) {
    return (0, _formUtils.isEmailValid)(val);
  });
};

var validationRules = function validationRules(label, value) {
  var allowMultiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var delimiter = arguments.length > 3 ? arguments[3] : undefined;
  if ((0, _valueCheck.isValueFalsey)(value)) return "";
  var emails = value.split(delimiter || ";");

  if (emails.length === 1 || allowMultiple && emails.length > 1) {
    return emailsAreValid(emails) ? "" : (0, _states.invalidInputState)(label).msg;
  } else {
    return (0, _states.invalidInputState)(label).msg;
  }
};

exports.validationRules = validationRules;